import React, {Fragment} from 'react';
import {FormattedMessage} from 'react-intl';
import classNames from 'classnames';
import {SVGIcon} from '@homeaway/react-svg';
import {INSTANT_BOOK__16} from '@homeaway/svg-defs';

// eslint-disable-next-line
const listingHasPriceInfo = (
    priceSummary,
    priceSummarySecondary,
    priceLabel
) => {
    return (
        (priceSummary && priceSummary.formattedAmount) ||
        (priceSummarySecondary && priceSummarySecondary.formattedAmount) ||
        (priceLabel && priceLabel.formattedAmount)
    );
};

const getListingPrices = (priceSummary, priceSummarySecondary) => {
    const defaultPrice = {
        priceTypeId: 'UNKNOWN',
        pricePeriodDescription: '',
        formattedAmount: '',
        roundedFormattedAmount: '',
    };
    const listingPriceSummary = priceSummary || defaultPrice;
    const listingPriceSummarySecondary = priceSummarySecondary || defaultPrice;
    const listingPriceSummaryId = listingPriceSummary.priceTypeId;
    const listingPriceSummarySecondaryId =
        listingPriceSummarySecondary.priceTypeId;
    let nightlyPrice = {};
    let totalPrice = {};

    if (
        listingPriceSummaryId === 'PER_NIGHT' ||
        listingPriceSummarySecondaryId === 'UNKNOWN'
    ) {
        nightlyPrice = {
            ...listingPriceSummary,
            isPriceBold: true,
            isPrimary: true,
        };
        totalPrice = {
            ...listingPriceSummarySecondary,
            isPriceBold: false,
            isPrimary: false,
        };
    } else {
        totalPrice = {
            ...listingPriceSummary,
            isPriceBold: true,
            isPrimary: true,
        };
        nightlyPrice = {
            ...listingPriceSummarySecondary,
            isPriceBold: false,
            isPrimary: false,
        };
    }

    return {
        nightlyPrice,
        totalPrice,
    };
};

const DualPriceElement = (props) => {
    const {instantBookable, priceSummary, priceSummarySecondary, priceLabel} =
        props.infoWindowOptions;
    const isDesktop = props.isDesktop;
    if (!listingHasPriceInfo(priceSummary, priceSummarySecondary, priceLabel)) {
        return (
            <span
                className="Price Price--noPrice"
                data-wdio="Price"
                data-price="0"
            >
                <FormattedMessage
                    id={'ratesNone'}
                    description={'no price'}
                    defaultMessage={'View details for price'}
                >
                    {(txt) => <span className="Price__Fallback">{txt}</span>}
                </FormattedMessage>
            </span>
        );
    }
    const {nightlyPrice, totalPrice} = getListingPrices(
        priceSummary,
        priceSummarySecondary
    );

    const renderPriceItem = (item, key) => {
        const {
            pricePeriodDescription,
            formattedAmount,
            roundedFormattedAmount,
            isPrimary,
        } = item;
        const isInstantBookable = instantBookable && isPrimary;
        if (
            !pricePeriodDescription &&
            !formattedAmount &&
            !roundedFormattedAmount
        ) {
            return null;
        }
        const styleClass = classNames('', {
            DualPrice__primary: item.isPrimary,
            DualPrice__secondary: !item.isPrimary,
            'DualPrice__main-price': item.isPriceBold,
        });
        const stylePeriodClass = classNames('', {
            DualPrice__period: true,
            DualPrice__period_amount:
                !roundedFormattedAmount && !formattedAmount,
        });

        return (
            <span key={key} className={styleClass}>
                {isInstantBookable && (
                    <span className="DualPrice__instantBook_icon">
                        <InstantBookIcon />
                    </span>
                )}
                <span className="DualPrice__amount">
                    {roundedFormattedAmount || formattedAmount}
                </span>
                <span className={stylePeriodClass}>
                    {pricePeriodDescription}
                </span>
            </span>
        );
    };

    let prices = [nightlyPrice, totalPrice];
    // for mobile view primary item should always be first
    if (!isDesktop && !prices[0].isPrimary) {
        prices = prices.reverse();
    }
    return (
        <Fragment>
            {prices.map((price, index) =>
                renderPriceItem(price, `price_${index}`)
            )}
            <span className="DualPrice__priceLabel">
                {priceLabel && priceLabel.pricePeriodDescription}
            </span>
        </Fragment>
    );
};

const InstantBookIcon = () => {
    return (
        <span
            className="InstantBookIcon"
            aria-hidden="true"
            title="Book without waiting for owner approval"
        >
            <SVGIcon markup={INSTANT_BOOK__16} inline />
        </span>
    );
};

export {DualPriceElement, InstantBookIcon};
